// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoginRequired_container__EKo3W.LoginRequired_blur__SZMRi {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  z-index: 1 !important;
}

.LoginRequired_login-container__0qy6G {
  position: relative !important;
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 8px !important;
  overflow: hidden !important;
  width: 100% !important;
  margin: 0 auto !important;
}
.LoginRequired_login-container__0qy6G.LoginRequired_simple__2C48i {
  flex-direction: column !important;
}

.LoginRequired_blur-cover__o3A6H {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  backdrop-filter: blur(8px) !important;
}

.LoginRequired_image-container__QgRYJ {
  position: relative !important;
  width: 100% !important;
  height: auto !important;
  overflow: hidden !important;
  max-width: 300px !important;
}
.LoginRequired_image-container__QgRYJ .LoginRequired_top-image__AJYu8 {
  width: 100% !important;
  height: auto !important;
  object-fit: cover !important;
  display: block !important;
}

.LoginRequired_content-container__hGIVL {
  position: relative !important;
  width: 100% !important;
  max-width: 450px !important;
  padding: 24px !important;
}

.LoginRequired_title-container__jomCW {
  margin-bottom: 24px !important;
}

.LoginRequired_title__MMkU\\+ {
  font-weight: 600 !important;
  margin-bottom: 8px !important;
  text-align: center !important;
}

.LoginRequired_subtitle__BmX4T {
  color: rgba(0, 0, 0, 0.6) !important;
  text-align: center !important;
}

.LoginRequired_login-options__VRMQv {
  display: flex !important;
  flex-direction: column !important;
  gap: 16px !important;
}

.LoginRequired_third-party-options__-CHQn {
  display: flex !important;
  flex-direction: column !important;
  gap: 16px !important;
}
.LoginRequired_third-party-options__-CHQn.LoginRequired_simple__2C48i {
  flex-direction: row !important;
  gap: 8px !important;
}
.LoginRequired_third-party-options__-CHQn.LoginRequired_simple__2C48i button .MuiButton-icon {
  margin: 0 !important;
}

.LoginRequired_login-button__Dc8eE {
  text-transform: none !important;
  padding: 10px 0 !important;
  border-radius: 4px !important;
  min-width: 0 !important;
}

.LoginRequired_divider__4JHgz {
  margin: 8px 0 !important;
}

@media (max-width: 600px) {
  .LoginRequired_login-container__0qy6G {
    max-width: 100% !important;
    border-radius: 0 !important;
  }
  .LoginRequired_content-container__hGIVL {
    padding: 16px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/LoginRequired/LoginRequired.module.scss"],"names":[],"mappings":"AACE;EACE,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EAEA,qBAAA;AADJ;;AAKA;EACE,6BAAA;EACA,wBAAA;EACA,8BAAA;EACA,8BAAA;EACA,kCAAA;EACA,6BAAA;EACA,2BAAA;EACA,sBAAA;EACA,yBAAA;AAFF;AAIE;EACE,iCAAA;AAFJ;;AAMA;EACE,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,qCAAA;AAHF;;AAMA;EACE,6BAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,2BAAA;AAHF;AAKE;EACE,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,yBAAA;AAHJ;;AAOA;EACE,6BAAA;EACA,sBAAA;EACA,2BAAA;EACA,wBAAA;AAJF;;AAOA;EACE,8BAAA;AAJF;;AAOA;EACE,2BAAA;EACA,6BAAA;EACA,6BAAA;AAJF;;AAOA;EACE,oCAAA;EACA,6BAAA;AAJF;;AAOA;EACE,wBAAA;EACA,iCAAA;EACA,oBAAA;AAJF;;AAOA;EACE,wBAAA;EACA,iCAAA;EACA,oBAAA;AAJF;AAME;EACE,8BAAA;EACA,mBAAA;AAJJ;AAOM;EACE,oBAAA;AALR;;AAWA;EACE,+BAAA;EACA,0BAAA;EACA,6BAAA;EACA,uBAAA;AARF;;AAWA;EACE,wBAAA;AARF;;AAWA;EACE;IACE,0BAAA;IACA,2BAAA;EARF;EAWA;IACE,wBAAA;EATF;AACF","sourcesContent":[".container {\n  &.blur {\n    position: absolute !important;\n    top: 0 !important;\n    left: 0 !important;\n    width: 100% !important;\n    // height: 100% !important;\n    z-index: 1 !important;\n  }\n}\n\n.login-container {\n  position: relative !important;\n  display: flex !important;\n  flex-direction: row !important;\n  align-items: center !important;\n  justify-content: center !important;\n  border-radius: 8px !important;\n  overflow: hidden !important;\n  width: 100% !important;\n  margin: 0 auto !important;\n\n  &.simple {\n    flex-direction: column !important;\n  }\n}\n\n.blur-cover {\n  position: absolute !important;\n  top: 0 !important;\n  left: 0 !important;\n  width: 100% !important;\n  height: 100% !important;\n  backdrop-filter: blur(8px) !important;\n}\n\n.image-container {\n  position: relative !important;\n  width: 100% !important;\n  height: auto !important;\n  overflow: hidden !important;\n  max-width: 300px !important;\n\n  .top-image {\n    width: 100% !important;\n    height: auto !important;\n    object-fit: cover !important;\n    display: block !important;\n  }\n}\n\n.content-container {\n  position: relative !important;\n  width: 100% !important;\n  max-width: 450px !important;\n  padding: 24px !important;\n}\n\n.title-container {\n  margin-bottom: 24px !important;\n}\n\n.title {\n  font-weight: 600 !important;\n  margin-bottom: 8px !important;\n  text-align: center !important;\n}\n\n.subtitle {\n  color: rgba(0, 0, 0, 0.6) !important;\n  text-align: center !important;\n}\n\n.login-options {\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 16px !important;\n}\n\n.third-party-options {\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 16px !important;\n\n  &.simple {\n    flex-direction: row !important;\n    gap: 8px !important;\n\n    button {\n      :global(.MuiButton-icon) {\n        margin: 0 !important;\n      }\n    }\n  }\n}\n\n.login-button {\n  text-transform: none !important;\n  padding: 10px 0 !important;\n  border-radius: 4px !important;\n  min-width: 0 !important;\n}\n\n.divider {\n  margin: 8px 0 !important;\n}\n\n@media (max-width: 600px) {\n  .login-container {\n    max-width: 100% !important;\n    border-radius: 0 !important;\n  }\n\n  .content-container {\n    padding: 16px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `LoginRequired_container__EKo3W`,
	"blur": `LoginRequired_blur__SZMRi`,
	"login-container": `LoginRequired_login-container__0qy6G`,
	"simple": `LoginRequired_simple__2C48i`,
	"blur-cover": `LoginRequired_blur-cover__o3A6H`,
	"image-container": `LoginRequired_image-container__QgRYJ`,
	"top-image": `LoginRequired_top-image__AJYu8`,
	"content-container": `LoginRequired_content-container__hGIVL`,
	"title-container": `LoginRequired_title-container__jomCW`,
	"title": `LoginRequired_title__MMkU+`,
	"subtitle": `LoginRequired_subtitle__BmX4T`,
	"login-options": `LoginRequired_login-options__VRMQv`,
	"third-party-options": `LoginRequired_third-party-options__-CHQn`,
	"login-button": `LoginRequired_login-button__Dc8eE`,
	"divider": `LoginRequired_divider__4JHgz`
};
export default ___CSS_LOADER_EXPORT___;
